<template>
    <div class="full-width-form" v-loading="loading">
        <div class="item-list-part">
            <el-scrollbar>
                <quotationItemRecord v-for="(v, i) in itemList" :key="v.ProductID" :obj="v" />

                <div class="delivery-remark">
                    <div>
                        <span style="color: #303133" tkey="運輸備註">{{i18n.tkey("lang_delivery_remark")}}</span>
                    </div>

                    <div>
                        <span>{{deliveryRemark}}</span>
                    </div>
                </div>
            </el-scrollbar>
        </div>

        <div class="total-part">
            <div class="text-part">
                <div>
                    <span style="font-weight: 600" tkey="總金額">{{i18n.tkey("lang_bill_total")}}</span>
                </div>

                <div>
                    <span class="price-label">
                        <span>{{companyInfo.currcode}}</span>
                        &nbsp;
                        <span>{{totalSum}}</span>
                    </span>
                </div>
            </div>

            <div>
                <button class="submit-btn" @click="submitOrder" tkey="提交">{{i18n.tkey("lang_submit")}}</button>
            </div>
        </div>
    </div>
</template>

<script setup>
    import {inject, ref, onBeforeMount, toRef} from "vue";
    import eshopopeeApi from "@/request/eshopopeeApi";
    import quotationItemRecord from "@/components/shopopee/quotation/quotationItemRecord"
    import myUtil from "@/util/util";
    import {useUserinfo} from "@/stores/userinfo";

    const props = defineProps(["materialList"])
    const emits = defineEmits(["save-complete"])

    const userInfoRef = toRef(useUserinfo())
    const i18n = inject("i18n")

    const companyInfo = ref({})

    const { getCompanyObj } = inject('quotationMain', { getCompanyObj: () => { return {} } })
    const { goMyQuotation } = inject('phoneView', { goMyQuotation: () => {  } })

    const itemList = ref([])
    const deliveryRemark = ref("")

    const totalSum = ref(0)

    const loading = ref(false)

    function getItemListInfo(){
        let ids = ""
        let pids = ""

        props.materialList.forEach((v, i) => {
            if (-1 != v.ID){
                ids += `${v.ID},`
            }else{
                pids += `'${v.ProductID}',`
            }

        })

        if (ids.length > 0){
            ids = ids.substring(0, ids.length - 1)
        }

        if (pids.length > 0){
            pids = pids.substring(0, pids.length - 1)
        }

        const request = eshopopeeApi.getMateriaListByQtyIDList
        const params = request.getParams()

        params.companycode = companyInfo.value.acccompanycode
        params.idList = ids
        params.productIDList = pids
        params.countrycode = userInfoRef.value.country

        request.send(params, (res) => {
            if (res.code == 200){
                let list = []
                let num = 0

                if (null != res.detail && res.detail.length > 0){
                    res.detail.forEach((v, i) => {
                        num += myUtil.MathFix(v.BiggerThan, v.CCost, "*")
                        list.push(v)
                    })
                }

                if (null != res.items && res.items.length > 0){
                    res.items.forEach((v, i) => {
                        v.CID = -1
                        v.CCost = v.Cost
                        v.BiggerThan = 1
                        num += myUtil.MathFix(v.BiggerThan, v.CCost, "*")
                        list.push(v)
                    })
                }

                if (null != res.delivery && res.delivery.length > 0){
                    let allObj = null
                    let countryObj = null

                    for (let i=0; i<res.delivery.length; i++){
                        const v = res.delivery[i]

                        if ("all" == v.District1){
                            allObj = v
                            continue
                        }

                        if (v.District1 == userInfoRef.value.country){
                            countryObj = v
                            break
                        }
                    }

                    if (null != countryObj){
                        if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
                            deliveryRemark.value = countryObj.ShipmentAddress
                        }else{
                            deliveryRemark.value = countryObj.ShipmentAddressCN
                        }
                    }else if(null != allObj){
                        if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
                            deliveryRemark.value = allObj.ShipmentAddress
                        }else{
                            deliveryRemark.value = allObj.ShipmentAddressCN
                        }
                    }else{
                        deliveryRemark.value = ""
                    }

                }

                itemList.value = list
                totalSum.value = num
            }
        })

    }

    function submitOrder(){
        loading.value = true

        let ProductID = ""
        let qty = ""
        let unit = ""
        let price = ""

        itemList.value.forEach((v, i) => {
            if (i < itemList.value.length - 1){
                ProductID += v.ProductID + ","
                qty += v.BiggerThan + ","
                price += v.CCost + ","
                unit += v.Unit + ","
            }else{
                ProductID += v.ProductID
                qty += v.BiggerThan
                price += v.CCost
                unit += v.Unit
            }
        })


        const request = eshopopeeApi.submitQuotation
        const params = request.getParams()

        params.CompanyCode = companyInfo.value.acccompanycode
        params.ShopopeeLogin = userInfoRef.value.login
        params.ShopopeePassword = userInfoRef.value.password
        params.productID = ProductID
        params.qty = qty
        params.unit = unit
        params.price = price
        params.deliveryRemark = deliveryRemark.value

        request.send(params, (res) => {
            loading.value = false

            if (res.status == 1){
                myUtil.confirmSuccess(i18n.tkey("lang_submit_quotation_confirm_1"), () => {
                    goMyQuotation()
                    emits("save-complete")
                }, () => {
                    emits("save-complete")
                })

            }
        })

    }

    onBeforeMount(() => {
        companyInfo.value = getCompanyObj()

        if (props.materialList != null && props.materialList.length > 0){
            getItemListInfo()
        }

    })

</script>

<style scoped>
    .full-width-form {
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        box-sizing: border-box;
        padding: 15px;
    }

    .item-list-part {
        width: 100%;
        height: calc(100% - 110px);
        overflow-x: hidden;
        overflow-y: auto;
        box-sizing: border-box;
    }

    .total-part {
        width: 100%;
        height: 65px;
        box-sizing: border-box;
        margin-top: 40px;
        line-height: 2;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #ffffff;
    }

    .submit-btn {
        background: #e83f33;
        color: #fff;
        border: 1px solid #e83f33;
        font-size: 16px;
        font-weight: 600;
        padding: 8px 30px;
        border-radius: 3px;
        text-transform: uppercase;
    }

    .price-label {
        color: #e83f33;
    }

    .text-part {
        font-size: 16px;
        text-align: left;
    }

    .delivery-remark {
        margin-top: 15px;
        box-sizing: border-box;
        padding: 10px;
        background: #F5F7FA;
        font-size: 14px;
        color: #606266;
        text-align: left;
        line-height: 2;
    }

</style>